// extracted by mini-css-extract-plugin
module.exports = {"closeAlertButton":"EGiftCard_closeAlertButton__3Tdjn","imageUploader":"EGiftCard_imageUploader__4gAzx"};